import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store, { persistor } from "app/store";
import { PersistGate } from "redux-persist/integration/react";
import cookie from "js-cookie";
import { logout, setUser } from "app/reducer/authSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/js/bootstrap.bundle";
import "./assets/scss/app.scss";
// import "react-toastify/dist/ReactToastify.css";
import "./global.css";
import "./util/TextHighlighter";
import {
  setApiError,
  setApiConfig,
  setAccessError,
  setAssessmentNotAvailableError,
  setSubmitApiError
} from "app/reducer/errorSlice";
import ReduxThemeProvider from 'common/HOC/ReduxThemeProvider'

/**
 * Register the network-only worker so ChromeOS can install this portal as a
 * managed PWA without adding offline assessment behavior to the application.
 */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`);
  });
}

/**
 * Suppress the browser context menu only when the portal is launched as an
 * installed PWA window. Normal Chrome tabs keep right-click available for QA.
 */
if (window.matchMedia("(display-mode: standalone)").matches) {
  window.addEventListener("contextmenu", (event) => {
    event.preventDefault();
  });
}

if (cookie.get("token")) {
  let user = cookie.get("user");
  if (user) {
    store.dispatch(setUser(user));
  }
}
const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ReduxThemeProvider>
          <App />
        </ReduxThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

export const setErrorForStatus400 = (isError: boolean) => {
  store.dispatch(setAccessError(isError));
};

export const setErrorForStatus5021 = (isError: boolean) => {
  store.dispatch(setAssessmentNotAvailableError(isError));
};

export const logoutAction = () => {
  store.dispatch(logout());
};

export const ApiFailure = {
  setApiError: (value: boolean, request?: any) => {
    if (value) {
      store.dispatch(setApiConfig(request));
    } else {
      store.dispatch(setApiConfig(null));
    }
    store.dispatch(setApiError(value));
  },
  setSubmitApiError: (value: boolean, request?: any) => {
    store.dispatch(setSubmitApiError(value));
  }
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
